import React from "react";
import LegalPage from "../../components/LegalPage";

const PDF = "https://customer-assets.emergentagent.com/job_workflow-builder-125/artifacts/4sbqanqp_Zelaflo_Labs_Service_Level_Agreement.pdf";

export default function ServiceLevelAgreement() {
  return (
    <LegalPage
      title="Service Level Agreement"
      pdfUrl={PDF}
      description="Uptime, response time, and support commitments for Zelaflo Labs clients."
      testId="legal-sla"
    />
  );
}
